import parser from "ua-parser-js";
const parsedUA = parser(navigator.userAgent);

export function getOS() {
  return parsedUA.os.name || 'Unknown';
}

export function getBrowser() {
  return parsedUA.browser.name || 'Unknown';
}